export const maskOptions = {
  autoUnmask: true,
  showMaskOnHover: false
};

export const phoneMaskOptions = {
  ...maskOptions,
  mask: '+7 (999) 999-99-99'
};

export const snilsMaskOptions = {
  ...maskOptions,
  mask: '999-999-999 99'
};

export const passporRfMaskOptions = {
  ...maskOptions,
  mask: '99 99 999999'
};

export const birthCertificateRfMaskOptions = {
  ...maskOptions,
  casing: 'upper',
  regex: '[IVXLCDM]{1,4}-[А-ЯЁ]{2} [0-9]{6}'
};
